import { Box, CardContent, Link, Stack } from '@mui/material';
import { MprcCard, MprcContainer, MprcRequestErrorReport, MprcRequestIndicator, MprcTypography } from 'components';
import { FeedItemDto } from 'generated/CoreApi_v1';
import { useCoreApi } from 'providers/CoreApiProvider';
import { QRCodeCanvas } from 'qrcode.react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useParams } from 'react-router';
import { KnowledgePaths } from 'routes/KnowledgeRouter';

////////////////////////////////////////////////////////////////////////////

export const PublicationQrCode: React.FC = () => {

    const api = useCoreApi();
    const { t } = useTranslation("lms");
    const { publicationId } = useParams();

    const [loading, setLoading] = useState<boolean>(false);
    const [viewData, setViewData] = useState<FeedItemDto>();
    const [viewError, setViewError] = useState<any>();

    ////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        setLoading(true);
        api.v1.knowledgeFeed.getFeedItem({
            markRead: false,
            publicationId: publicationId!
        })
            .then(response => {
                setViewData(response.data);
            })
            .catch(e => setViewError(e))
            .finally(() => setLoading(false));
    }, []);

    ////////////////////////////////////////////////////////////////////////////


    return (
        <>
            <MprcRequestIndicator visible={loading} />

            {
                viewError
                    ? <MprcRequestErrorReport error={viewError} />
                    : !loading && viewData &&
                    <>
                        <MprcContainer>
                            <Stack alignItems="end" sx={theme => ({ backgroundColor: theme.palette.notice.main, py: 1, px: 3 })} className="no-print">
                                <Link variant="body1" textTransform="uppercase" onClick={() => window.print()}>{t("Meeting.AttendanceList.PrintButtonText")}</Link>
                            </Stack>
                        </MprcContainer>

                        <Box margin="0 auto" width={572}>
                            <MprcCard
                                variant="outlined"
                                elevation={0}
                                borderRadius="md"
                                sx={theme => ({ borderColor: theme.palette.muted.light })}
                            >
                                <Box height="120px"
                                    bgcolor={theme => theme.palette.paper.main}
                                    sx={{
                                        printColorAdjust: "exact",
                                        WebkitPrintColorAdjust: "exact"
                                    }}
                                >
                                    <Stack spacing={1} justifyContent="center" px={2} height="100%">
                                        <MprcTypography noWrapRows={2} variant="h2" color="black">{viewData.title}</MprcTypography>
                                    </Stack>
                                </Box>
                                <CardContent sx={theme => ({
                                    height: 400,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderTop: 1,
                                    borderBottom: 1,
                                    borderColor: theme.palette.muted.light,
                                    borderWidth: 1
                                })}>
                                    <QRCodeCanvas
                                        size={300}
                                        value={window.location.protocol + "//" + window.location.host + KnowledgePaths.PublicationViewerResolver(viewData!.publicationId, viewData!.publicationType)}
                                    />
                                </CardContent>
                                <Box
                                    height="120px"
                                    bgcolor={theme => theme.palette.paper.main}
                                    sx={{
                                        printColorAdjust: "exact",
                                        WebkitPrintColorAdjust: "exact",
                                    }}
                                >
                                    <Stack spacing={1} justifyContent="center" height="100%" width="100%" px={2}>
                                        <MprcTypography noWrapRows={2} variant="h5" color="black">{viewData.classificationTypeName}</MprcTypography>
                                        <MprcTypography noWrapRows={2} variant="h5" color="black">{viewData.author.fullName}</MprcTypography>
                                    </Stack>
                                </Box>
                            </MprcCard>
                        </Box>
                    </>
            }
        </>
    );
};
